import { values } from 'lodash';

import { CommunicationSessionType } from '../../../../../objects/call/communication-session-type';
import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { CommunicationsResponseSchema } from '../../generic/communications-response/communications-response-schema';

import { CommunicationsResponseGetSessionIdError } from './communications-response-get-session-id-error';

export class CommunicationsResponseGetSessionIdSchema extends CommunicationsResponseSchema {
  public static readonly sessionId = 'sessionId';

  public static readonly sessionType = 'sessionType';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly type = undefined;

    public static readonly error = undefined;

    public static readonly sessionId = undefined;

    public static readonly sessionType = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Schema for this object is encoded into a command name, and in parameters
   */
  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    /* eslint-disable */
    parameters[CommunicationsResponseGetSessionIdSchema.error] = SchemaField.string(
      CommunicationsResponseSchema.Defaults.error,
    )
      .optional()
      .valid(...values(CommunicationsResponseGetSessionIdError));

    parameters[CommunicationsResponseGetSessionIdSchema.sessionId] = SchemaField.autoGeneratedDocId(
      CommunicationsResponseGetSessionIdSchema.Defaults.sessionId,
    ).optional();

    parameters[CommunicationsResponseGetSessionIdSchema.sessionType] = SchemaField.string(
      CommunicationsResponseGetSessionIdSchema.Defaults.sessionType,
    )
      .optional()
      .valid(...values(CommunicationSessionType));
    /* eslint-enable */

    return parameters;
  }
}
